var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "breadcrumb-layout" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "/" } },
            [
              _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                _vm._v("首页")
              ]),
              _vm._v(" "),
              _c("el-breadcrumb-item", [_vm._v("报价")])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("el-form", [
        _c("div", { staticClass: "bid-container" }, [
          _c("div", { staticClass: "content-caption dashed bg-white" }, [
            _c("span", [_vm._v("询价信息")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title" }, [_vm._v("询价标题")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("label", { staticClass: "mr20" }, [
                _vm._v(_vm._s(_vm.priceReplyInfo.inqryTitle))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title" }, [_vm._v("询价方")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("label", { staticClass: "mr20" }, [
                _vm._v(_vm._s(_vm.priceReplyInfo.inqryMerchantName))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title" }, [_vm._v("询价日期")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("label", { staticClass: "mr20" }, [
                _vm._v(
                  _vm._s(_vm.priceInpryInfo.publishTime) +
                    " ~ " +
                    _vm._s(_vm.priceInpryInfo.expireDate)
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed bg-white" }, [
            _c("span", [_vm._v("询价服务")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "fr font-gray1",
                staticStyle: { "font-size": "12px" }
              },
              [
                _vm._v("\n                    优惠合计： "),
                _c(
                  "span",
                  {
                    staticClass: "font-bold",
                    class: {
                      "font-red": _vm.totalServcDiscount <= 0,
                      "font-green": _vm.totalServcDiscount > 0
                    }
                  },
                  [_vm._v(_vm._s(_vm.totalServcDiscount))]
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "table-layout" },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.priceReplyInfo.servcList, border: "" }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "servcImage",
                      width: "150",
                      label: "服务图片",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            _c("img", { attrs: { src: rows.row.servcImage } })
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "name", label: "服务名称", align: "left" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "price",
                      label: "市场单价(元)",
                      width: "150",
                      align: "right"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  rows.row.priceNegoFlag
                                    ? "面议"
                                    : rows.row.price
                                )
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "呈报单价(元)",
                      width: "120",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.number",
                                  value: scope.row.replyPrice,
                                  expression: "scope.row.replyPrice",
                                  modifiers: { number: true }
                                }
                              ],
                              staticClass: "align-right",
                              staticStyle: { width: "100px" },
                              attrs: { type: "text" },
                              domProps: { value: scope.row.replyPrice },
                              on: {
                                blur: [
                                  function($event) {
                                    _vm.calcGoodsDiscount(
                                      scope.$index,
                                      scope.row
                                    )
                                  },
                                  function($event) {
                                    _vm.$forceUpdate()
                                  }
                                ],
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    scope.row,
                                    "replyPrice",
                                    _vm._n($event.target.value)
                                  )
                                }
                              }
                            })
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "discount",
                      label: "优惠小计(元)",
                      width: "120",
                      align: "right"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            _c(
                              "span",
                              {
                                staticClass: "font-bold",
                                class: {
                                  "font-red": rows.row.discount <= 0,
                                  "font-green": rows.row.discount > 0
                                }
                              },
                              [_vm._v(_vm._s(rows.row.discount))]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title" }, [_vm._v("要求交付期")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("span", { staticClass: "width-1-5x" }, [
                _vm._v("  " + _vm._s(_vm.priceReplyInfo.inqryDeliverPeriod)),
                _c("span", { staticClass: "ml15" }),
                _c("span", { staticClass: "ml30" }, [_vm._v("天")])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title required" }, [
              _vm._v("呈报交付期")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content" },
              [
                _c(
                  "el-form-item",
                  { staticClass: "fl", attrs: { prop: "deliverPeriod" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "140px" },
                      attrs: { placeholder: "", type: "number", min: "1" },
                      model: {
                        value: _vm.priceReplyInfo.deliverPeriod,
                        callback: function($$v) {
                          _vm.$set(_vm.priceReplyInfo, "deliverPeriod", $$v)
                        },
                        expression: "priceReplyInfo.deliverPeriod"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "fl font-gray1 ml10" }, [_vm._v("天")])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title" }, [_vm._v("联系人")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "contactName" } },
                  [
                    _c("el-input", {
                      staticClass: "width-1-5x",
                      attrs: { placeholder: "" },
                      model: {
                        value: _vm.priceReplyInfo.contactName,
                        callback: function($$v) {
                          _vm.$set(_vm.priceReplyInfo, "contactName", $$v)
                        },
                        expression: "priceReplyInfo.contactName"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title" }, [_vm._v("联系电话")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "contactTel" } },
                  [
                    _c("el-input", {
                      staticClass: "width-1-5x",
                      attrs: { placeholder: "" },
                      model: {
                        value: _vm.priceReplyInfo.contactTel,
                        callback: function($$v) {
                          _vm.$set(_vm.priceReplyInfo, "contactTel", $$v)
                        },
                        expression: "priceReplyInfo.contactTel"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title" }, [_vm._v("交易规则")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content" },
              [
                _c("swb-create-trade-rule", {
                  ref: "swb_create_trade_rule",
                  attrs: {
                    comparedTradeRuleList: _vm.comparedTradeRuleList,
                    type: _vm.tradeType,
                    forPriceInqry: _vm.forPriceInqry,
                    forGoods: _vm.forGoods,
                    forServc: _vm.forServc,
                    returnType: _vm.returnType
                  }
                })
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "form-toolbar align-center mt30",
          staticStyle: { padding: "0" }
        },
        [
          _c(
            "button",
            {
              staticClass: "swb-btn mr20",
              on: {
                click: function($event) {
                  _vm.savePriceInpry()
                }
              }
            },
            [_vm._v("保存")]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07dd5a47", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07dd5a47","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/priceReply/PriceReplySave.vue
// module id = 2087
// module chunks = 1